import { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { Portal } from '@elfsight/widget-modal';
import { useA11yState } from '../hooks/use-a11y-state';

const LINE_HEIGHT_PX = 10;

export function ReadingLine() {
  const { a11yState: { readingLine } = {} } = useA11yState();
  const [mouseY, setMouseY] = useState(0);

  const bottom = useMemo(() => {
    if (mouseY > 0) {
      return `calc(100vh - ${mouseY}px - ${LINE_HEIGHT_PX}px - 1px)`;
    }

    return 0;
  }, [mouseY]);

  useEffect(() => {
    if (!readingLine) {
      return;
    }

    const handleMouseMove = (event: MouseEvent) => setMouseY(event.clientY);

    window.addEventListener('mousemove', handleMouseMove);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, [readingLine]);

  return (
    !!readingLine && (
      <Portal>
        <Line style={{ bottom }} />
      </Portal>
    )
  );
}

const Line = styled.div`
  position: fixed;
  top: auto;
  left: 0;
  right: 0;
  pointer-events: none;
  height: ${LINE_HEIGHT_PX}px;
  background-color: rgb(25, 123, 255);
  z-index: 9999999; // it should be under floating button and modals
`;
